import gql from 'graphql-tag';

export const PLAN_VERSION_FIELDS = gql`
	fragment PlanVersionFields on PlanVersion {
		_id
		createdDate
		createdById
		lastModifiedDate
		lastModifiedById
		orgId
		planId
		isCurrent
		index
		revisionDate
		name
		status
		errorMessage
		totalPages
		readyPages
		hasReadyOCR
		progress
		useOCR
		recentlyUploadedPdfRequestId
	}
`;
